import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { FaCheck, FaExchangeAlt, FaTimes } from "react-icons/fa";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const DIALOG_STYLES = `
  .modal.show { display: block !important; opacity: 1 !important; }
  .modal.fade.show { opacity: 1 !important; }
  .mdl-class-change-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.45rem auto 1rem;
    max-width: 760px;
  }
  .mdl-class-change-dialog.modal-dialog.modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
  .modal-backdrop { z-index: 1040 !important; }
  .modal-backdrop.show { opacity: 0.5 !important; }
  .mdl-class-change-dialog .modal-content {
    z-index: 1051 !important;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    border: 2px solid rgba(179, 229, 252, 0.55);
    box-shadow: 0 12px 28px rgba(2, 136, 209, 0.14);
    background: #fff;
  }
  .mdl-class-change-dialog .modal-header {
    border: none;
    padding: 12px 16px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 55%, #01579b 100%);
  }
  .mdl-class-change-dialog .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.35rem;
    font-weight: 400;
    padding: 0.35rem 0.55rem;
  }
  .mdl-class-change-dialog .modal-body {
    padding: 12px 14px 10px;
    background: #fff;
  }
  .mdl-class-change-dialog .modal-footer {
    border-top: 1px solid #e1f5fe;
    padding: 10px 14px;
    background: #f0f9ff;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .mcc-title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 18px;
  }
  .mcc-title__icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .mcc-title__main { font-size: 16px; font-weight: 800; line-height: 1.2; }
  .mcc-title__sub {
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.88);
  }
  .mcc-filters {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    border: 2px solid ${COLORS.primary_color_shade3};
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .mcc-filter {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    min-width: 0;
  }
  .mcc-filter--board {
    background: linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade6} 100%);
  }
  .mcc-filter--medium {
    background: linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade7} 100%);
    border-left: 2px solid rgba(255,255,255,0.35);
  }
  .mcc-filter__label {
    margin: 0;
    font-size: 11px;
    font-weight: 800;
    color: ${COLORS.primary_color_shade9};
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
    padding: 4px 8px;
    border-radius: 6px;
    background: rgba(255,255,255,0.92);
    box-shadow: 0 1px 3px rgba(1, 87, 155, 0.15);
  }
  .mcc-filter__select {
    flex: 1;
    min-width: 0;
    padding: 7px 10px;
    font-size: 13px;
    border-radius: 8px;
    border: 2px solid rgba(255,255,255,0.65);
    background: #fff;
    font-weight: 700;
    color: ${COLORS.primary_color_shade9};
    outline: none;
  }
  .mcc-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
    gap: 6px;
    max-height: 320px;
    overflow-y: auto;
    padding: 2px;
    background: #fff;
  }
  .mcc-card {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    padding: 8px 10px;
    border-radius: 8px;
    border: 2px solid ${COLORS.primary_color_shade3};
    background: #fff;
    cursor: pointer;
    text-align: center;
    box-shadow: 0 1px 3px ${COLORS.primary_color_shade2}55;
    transition: all 0.15s ease;
  }
  .mcc-card:hover {
    border-color: ${COLORS.primary_color_shade5};
    background: ${COLORS.primary_color_shade1};
  }
  .mcc-card.is-selected {
    border-color: #2e7d32;
    background: linear-gradient(135deg, #66bb6a 0%, #43a047 55%, #2e7d32 100%);
    box-shadow: 0 0 0 2px rgba(46, 125, 50, 0.18);
  }
  .mcc-card__label {
    margin: 0;
    font-size: 12px;
    font-weight: 700;
    color: ${COLORS.primary_color_shade8};
    line-height: 1.25;
  }
  .mcc-card.is-selected .mcc-card__label {
    color: #fff;
    font-weight: 800;
  }
  .mcc-card__tick {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    color: #2e7d32;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.16);
  }
  .mcc-empty {
    text-align: center;
    padding: 28px 12px;
    border-radius: 10px;
    border: 2px dashed rgba(179, 229, 252, 0.7);
    background: #f8fcff;
    color: #607d8b;
    font-size: 13px;
    font-weight: 600;
  }
  .mcc-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 800;
    border: 2px solid transparent;
    cursor: pointer;
  }
  .mcc-btn:disabled { opacity: 0.55; cursor: not-allowed; }
  .mcc-btn--ghost {
    background: #fff;
    border-color: #b3e5fc;
    color: #0277bd;
  }
  .mcc-btn--ghost:hover:not(:disabled) { background: #e1f5fe; }
  .mcc-btn--primary {
    background: linear-gradient(135deg, #43a047 0%, #2e7d32 100%);
    border-color: #2e7d32;
    color: #fff;
  }
  @media (max-width: 640px) {
    .mcc-filters { grid-template-columns: 1fr; }
    .mcc-filter--medium { border-left: none; border-top: 2px solid rgba(255,255,255,0.35); }
  }
`;

//Created By Cursor
function buildFilteredClassSectionList(data, boardId, mediumId) {
  const filtered = [];
  const matched = (data || []).filter(
    (item) => String(item.board_id) === String(boardId) && String(item.medium_id) === String(mediumId)
  );
  matched.forEach((item) => {
    if (item.section === "No") {
      filtered.push({ ...item, section_id: "No" });
      return;
    }
    (item.section || []).forEach((section) => {
      filtered.push({
        ...section,
        board_id: boardId,
        board_name: item.board_name,
        medium_id: mediumId,
        medium_name: item.medium_name,
      });
    });
  });
  return filtered;
}

//Created By Cursor
function classCardLabel(item) {
  if (!item) return "—";
  if (item.section === "No" || item.section_id === "No" || !item.section_name) {
    return item.class_name || "—";
  }
  return `${item.class_name}:${item.section_name}`;
}

//Created By Cursor
const MdlClassChange = ({
  session_id,
  session_name,
  actionClose,
  actionSelectClass,
}) => {
  const sltBoardRef = useRef(null);
  const sltMediumRef = useRef(null);

  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [classBoard, setClassBoard] = useState([]);
  const [classMedium, setClassMedium] = useState([]);
  const [mClassData, setMClassData] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState(-1);

  useEffect(() => {
    if (document.querySelector("style[data-mdl-class-change='1']")) return;
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-mdl-class-change", "1");
    styleTag.textContent = DIALOG_STYLES;
    document.head.appendChild(styleTag);
  }, []);

  const classDataRef = useRef([]);
  const boardRef = useRef([]);
  const mediumRef = useRef([]);

  //Created By Cursor
  const applyFilter = useCallback((data) => {
    const source = data || classDataRef.current;
    if (!sltBoardRef.current || !sltMediumRef.current) {
      setFilteredList([]);
      return;
    }
    const boardId =
      sltBoardRef.current.selectedOptions[0]?.getAttribute("board_id");
    const mediumId =
      sltMediumRef.current.selectedOptions[0]?.getAttribute("medium_id");
    if (!boardId || !mediumId) {
      setFilteredList([]);
      return;
    }
    const next = buildFilteredClassSectionList(source, boardId, mediumId);
    setFilteredList(next);
    setSelectedPosition(-1);
  }, []);

  //Created By Cursor
  useEffect(() => {
    if (!session_id) {
      myToast.notify_warning("Session is missing.");
      return;
    }
    setLoading(true);
    axios
      .get(`${API_BASE()}getClass.php`, {
        params: {
          school_code: SessionManager.getSchoolCode(),
          session_id,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK") {
          const classData = response.data.class || [];
          const boards = response.data.board || [];
          const mediums = response.data.medium || [];
          classDataRef.current = classData;
          boardRef.current = boards;
          mediumRef.current = mediums;
          setMClassData(classData);
          setClassBoard(boards);
          setClassMedium(mediums);
        } else {
          myToast.notify_warning(response.api_remark);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("[MdlClassChange] getClass error:", error);
        myToast.notify_warning("Failed to load classes.");
      });
  }, [session_id]);

  // Apply filter after board/medium selects render with data
  useEffect(() => {
    if (classBoard.length > 0 && classMedium.length > 0 && mClassData.length > 0) {
      const timer = setTimeout(() => applyFilter(mClassData), 50);
      return () => clearTimeout(timer);
    }
  }, [classBoard, classMedium, mClassData, applyFilter]);

  //Created By Cursor
  const handleClose = () => {
    setShow(false);
    actionClose();
  };

  //Created By Cursor
  const handleBoardMediumChange = () => {
    setSelectedPosition(-1);
    applyFilter(mClassData);
  };

  //Created By Cursor
  const handleSubmit = () => {
    if (selectedPosition < 0 || !filteredList[selectedPosition]) {
      myToast.notify_warning("Select a destination class.");
      return;
    }
    const selected = filteredList[selectedPosition];
    actionSelectClass(
      selected.class_id,
      selected.section_id,
      selected.session_id || session_id,
      selected.board_id,
      selected.medium_id
    );
  };

  if (!loggedIn) return <Redirect to="/Login" />;

  const selectedLabel =
    selectedPosition >= 0 ? classCardLabel(filteredList[selectedPosition]) : "";

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      centered
      size="lg"
      dialogClassName="mdl-class-change-dialog"
      aria-labelledby="mdl-class-change-title"
    >
      <Modal.Header closeButton>
        <div className="mcc-title" id="mdl-class-change-title">
          <span className="mcc-title__icon" aria-hidden>
            <FaExchangeAlt />
          </span>
          <div>
            <div className="mcc-title__main">Select destination class</div>
            <div className="mcc-title__sub">
              {session_name
                ? `Session · ${session_name}`
                : "Same session · choose board, medium & class"}
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="mcc-empty">
            <MyLoader />
          </div>
        ) : (
          <>
            <div className="mcc-filters">
              <div className="mcc-filter mcc-filter--board">
                <label className="mcc-filter__label" htmlFor="mcc-board">
                  Board
                </label>
                <select
                  id="mcc-board"
                  className="mcc-filter__select"
                  ref={sltBoardRef}
                  onChange={handleBoardMediumChange}
                >
                  {classBoard.map((item) => (
                    <option key={item.board_id} board_id={item.board_id}>
                      {item.board_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mcc-filter mcc-filter--medium">
                <label className="mcc-filter__label" htmlFor="mcc-medium">
                  Medium
                </label>
                <select
                  id="mcc-medium"
                  className="mcc-filter__select"
                  ref={sltMediumRef}
                  onChange={handleBoardMediumChange}
                >
                  {classMedium.map((item) => (
                    <option key={item.medium_id} medium_id={item.medium_id}>
                      {item.medium_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {filteredList.length === 0 ? (
              <div className="mcc-empty">No classes for this board/medium.</div>
            ) : (
              <div className="mcc-grid" role="listbox" aria-label="Classes">
                {filteredList.map((item, index) => {
                  const selected = selectedPosition === index;
                  return (
                    <button
                      key={`${item.class_id}-${item.section_id}-${index}`}
                      type="button"
                      role="option"
                      aria-selected={selected}
                      className={`mcc-card${selected ? " is-selected" : ""}`}
                      onClick={() => setSelectedPosition(index)}
                    >
                      {selected ? (
                        <span className="mcc-card__tick" aria-hidden>
                          <FaCheck />
                        </span>
                      ) : null}
                      <p className="mcc-card__label">{classCardLabel(item)}</p>
                    </button>
                  );
                })}
              </div>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="mcc-btn mcc-btn--ghost" onClick={handleClose}>
          <FaTimes aria-hidden /> Cancel
        </button>
        <button
          type="button"
          className="mcc-btn mcc-btn--primary"
          onClick={handleSubmit}
          disabled={selectedPosition < 0}
        >
          <FaCheck aria-hidden />
          {selectedLabel ? `Change to ${selectedLabel}` : "Confirm change"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlClassChange;
